export const ACCURACY_MARKS = Array.from({ length: 9 }, (_, i) => ({ value: (i + 1) / 10 }));
